
import React, { useState, useEffect, useContext } from 'react';
import './SurveyResponses.css';
import baseApi from '../../common/api/base';
import convenienceApi from '../../common/api/convenience';
import viewport from '../../common/viewport';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import ModuleLoadingStatus from '../ModuleLoadingStatus/ModuleLoadingStatus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import logComponent from '../../common/logComponent';
import { format, parseISO, isBefore } from 'date-fns';
import SurveyResponsesSurveyList from './SurveyResponsesSurveyList';
import SurveyResponsesSurveyContactList from './SurveyResponsesSurveyContactList';
import SurveyResponsesSurveyDistributionList from './SurveyResponsesSurveyDistributionList';
import SurveyResponsesSurveyMonitoredIndividualList from './SurveyResponsesSurveyMonitoredIndividualList';
import SurveyResponsesDetail from './SurveyResponsesResponseDetail';

const RESPONSES_PER_LOAD = 50;

export default function SurveyResponses() {
  const environmentContext = useContext(EnvironmentContext);
  const { activeUser: user, hasToken } = environmentContext;
  const [singlePanelView, setSinglePanelView] = useState(viewport.getCurrent() === 'sm' || (viewport.getCurrent() === 'md' && environmentContext.activeUser.groupTypeString === 'Facility'));
  const [distributions, setDistributions] = useState(null);
  const [contacts, setContacts] = useState(null);
  const [monitoredIndividuals, setMonitoredIndividuals] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);
  const [dataError, setDartaError] = useState(false);
  const [surveyResponsesCollections, setSurveyResponsesCollections] = useState([]);
  const [surveyResponsesCollectionsOnDeck, setSurveyResponsesCollectionsOnDeck] = useState(null);
  const [visibleSurvey, setVisibleSurvey] = useState(null);
  const [visibleSurveyDistribution, setVisibleSurveyDistribution] = useState(null);
  const [visibleSurveyContact, setVisibleSurveyContact] = useState(null);
  const [visibleMonitoredIndividual, setVisibleMonitoredIndividual] = useState(null);
  const [visibleSurveyResponse, setVisibleSurveyResponse] = useState(null);
  const [currentMobileView, setCurrentMobileView] = useState('surveys');
  const [currentMobileViewPage, setCurrentMobileViewPage] = useState('summary');



  if (logComponent('SurveyResponses')) { console.debug('SurveyResponses rendered'); }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (logComponent('SurveyResponses')) { console.debug('SurveyResponses onMount'); }
    window.addEventListener('resize', checkViewport);
  }, []);


  useEffect(() => {
    if (logComponent('SurveyResponses')) { console.debug('SurveyResponses useEffect  [environmentContext.hasToken]'); }


    if (!hasToken) return;
    loadSurveyResponses();
  }, [environmentContext.hasToken])


  const checkViewport = () => {
    if (logComponent('SurveyResponses')) { console.debug('Messages checkViewport'); }
    const newSinglePanelView =
      viewport.getCurrent() === 'sm' ||
      (viewport.getCurrent() === 'md' && environmentContext.activeUser.groupTypeString === 'Facility');

    if (singlePanelView !== newSinglePanelView) {
      setSinglePanelView(newSinglePanelView);
    }
  }

  const loadSurveyResponses = () => {
    if (logComponent('SurveyResponses')) { console.debug('SurveyResponses loadSurveys'); }

    if (!hasToken) return;

    setSurveyResponsesCollections(null);
    setDistributions(null);
    setDataLoading(true);
    setDartaError(false);

    const sortOrder = 'SurveyResponseId';

    convenienceApi.getSurveyResponses(user, 0, RESPONSES_PER_LOAD * 2, sortOrder, null)
      .then(
        result => {
          setTheSurveyResponses(result, true);
          let visibleSurvey = (result.length > 0 ? result[0].survey : null);
          let visibleDistributions = (visibleSurvey ? visibleSurvey.surveyDistributions : null);

          setVisibleSurvey(visibleSurvey);
          setDistributions(visibleDistributions);
          setDataLoading(false);
          setDartaError(false);
        },
        error => {
          setSurveyResponsesCollections(null);
          setDistributions(null);
          setDataLoading(false);
          setDartaError(true);
        });




  }

  const setTheSurveyResponses = (responses, loadBoth) => {
    if (logComponent('SurveyResponses')) { console.debug('SurveyResponses setTheSurveyResponses'); }
    let existingResponses = [...surveyResponsesCollections];
    let responsesToAdd = [];
    let responsesOnDeckToAdd = [];
    if (loadBoth) {
      var totalCount = 0;
      for (var i = 0; i < responses.length; i++) {
        if (totalCount <= RESPONSES_PER_LOAD) {
          responsesToAdd.push(responses[i]);

        } else {
          responsesOnDeckToAdd.push(responses[i]);

        }

        totalCount = totalCount + responses[i].Count;

      }
    }
    else {
      responsesOnDeckToAdd = responses;
    }

    if (responsesToAdd.length > 0) {
      let newSurveyResponses = mergeSurveyResponses(existingResponses, responsesToAdd);
      setSurveyResponsesCollections(newSurveyResponses);
    }
    setSurveyResponsesCollectionsOnDeck(responsesOnDeckToAdd);


  }

  const mergeSurveyResponses = (sourceResponses, responsesToAdd) => {
    if (logComponent('SurveyResponses')) { console.debug('SurveyResponses mergeSurveyResponses'); }
    let existingResponses = [...sourceResponses];

    responsesToAdd.forEach((summary) => {
      let survey = summary.survey;

      let matchingSurveyIndex = existingResponses.findIndex(x => x.survey.surveyId == survey.surveyId);
      if (matchingSurveyIndex === -1) {
        existingResponses.push(summary);

      } else { //match distributions and add new or update existing if needed
        survey.surveyDistributions.forEach((surveyDistribution) => {
          let matchingSurveyDistributionIndex = existingResponses[matchingSurveyIndex].surveyDistributions.findIndex(x => x.surveyDistributionId === surveyDistribution.surveyDistributionId);
          if (matchingSurveyDistributionIndex === -1) {
            existingResponses[matchingSurveyIndex].surveyDistributions.push(surveyDistribution);
          } else {//match contacts and add new or update existing if needed
            surveyDistribution.surveyContacts.forEach((surveyContact) => {
              let matchingSurveyContactIndex = existingResponses[matchingSurveyIndex].surveyDistributions[matchingSurveyDistributionIndex].surveyContacts.findIndex(x => x.surveyContactId === surveyContact.surveyContactId);
              if (matchingSurveyContactIndex === -1) {
                existingResponses[matchingSurveyIndex].surveyDistributions[matchingSurveyDistributionIndex].surveyContacts.push(surveyContact);
              } else {//match monitored individuals and add new or update existing if needed
                surveyContact.monitoredIndividuals.forEach((monitoredIndividual) => {
                  let matchingMonitoredIndividualIndex = existingResponses[matchingSurveyIndex].surveyDistributions[matchingSurveyDistributionIndex].surveyContacts[matchingSurveyContactIndex].monitoredIndividuals.findIndex(x => x.monitoredIndividualId === monitoredIndividual.monitoredIndividualId);
                  if (matchingMonitoredIndividualIndex === -1) {
                    existingResponses[matchingSurveyIndex].surveyDistributions[matchingSurveyDistributionIndex].surveyContacts[matchingSurveyContactIndex].monitoredIndividuals.push(monitoredIndividual);
                  } else { //match responses and add new
                    monitoredIndividual.surveyResponses.forEach((surveyResponse) => {
                      let matchingSurveyResponseIndex = existingResponses[matchingSurveyIndex].surveyDistributions[matchingSurveyDistributionIndex].surveyContacts[matchingSurveyContactIndex].monitoredIndividuals[matchingMonitoredIndividualIndex].surveyResponses.findIndex(x => x.surveyResponseId === surveyResponse.surveyResponseId);
                      if (matchingSurveyResponseIndex === -1) {
                        existingResponses[matchingSurveyIndex].surveyDistributions[matchingSurveyDistributionIndex].surveyContacts[matchingSurveyContactIndex].monitoredIndividuals[matchingMonitoredIndividualIndex].surveyResponses.push(surveyResponse);
                      }
                    })

                  }
                })
              }

            })
          }
        })
      }
    });
    return existingResponses;
  }

  const loadMoreSurveyResponses = () => {
    if (logComponent('SurveyResponses')) { console.debug('SurveyResponses loadMoreSurveyResponses'); }
    if (!hasToken) return;
    let existingResponses = [...surveyResponsesCollections];
    let existingResponsesOnDeck = [...surveyResponsesCollectionsOnDeck];

    var totalResponsesLoaded = getTotalCountAllResponses();
    var newSurveyResponses = mergeSurveyResponses(existingResponses, existingResponsesOnDeck);
    setSurveyResponsesCollections(newSurveyResponses);
    setSurveyResponsesCollectionsOnDeck(null);

    // If there are no more responses to load, bail
    if (!shouldLoadMore()) return;

    const sortOrder = 'SurveyResponseId';

    convenienceApi.getSurveyResponses(user, totalResponsesLoaded, RESPONSES_PER_LOAD, sortOrder, null)
      .then(
        result => {
          setTheSurveyResponses(result, false);
        },
        error => {
          setSurveyResponsesCollectionsOnDeck(null);
        });



  }

  const shouldLoadMore = () => {
    if (logComponent('SurveyResponses')) { console.debug('SurveyResponses shouldLoadMore'); }
    let total = getTotalCountAllResponses();

    let isMultipleOfResponsesPerLoad = total % RESPONSES_PER_LOAD === 0;

    return isMultipleOfResponsesPerLoad;

  }

  const getTotalCountAllResponses = () => {
    if (logComponent('SurveyResponses')) { console.debug('SurveyResponses getTotalCountAllResponses'); }
    let existingResponses = [...surveyResponsesCollections];
    let existingResponsesOnDeck = [...surveyResponsesCollectionsOnDeck];

    let existingCount = existingResponses.map(item => item.Count).reduce((prev, next) => prev + next);
    let onDeckCount = existingResponsesOnDeck.map(item => item.Count).reduce((prev, next) => prev + next);

    return existingCount + onDeckCount;

  }

  const sortSurveyDistributions = () => {
    if (logComponent('SurveyResponses')) { console.debug('SurveyResponses sortSurveyDistributions'); }

    const newSWDC = surveyResponsesCollections
      .find(collection => collection.survey.surveyId === visibleSurvey.surveyId);

    if (!newSWDC) return;

    const newSurveyDistributions = newSWDC.surveyDistributions;
    const newSurveyResponsesCollections = [...surveyResponsesCollections];

    newSurveyDistributions.sort((a, b) => {
      return isBefore(parseISO(a.sendOn), parseISO(b.sendOn)) ? 1 : -1
    });

    newSurveyResponsesCollections.sort((a, b) => {

      return a.surveyName > b.surveyName ? 1 : -1;
    });

    setSurveyResponsesCollections(newSurveyResponsesCollections);
    setDistributions(newSurveyDistributions);

  }

  const setVisibleSurveyThis = (surveyResponseCollections) => {
    if (logComponent('SurveyResponses')) { console.debug('SurveyResponses setSurveyDistributionsThis'); }
    setVisibleSurvey(surveyResponseCollections);
    setDistributions(surveyResponseCollections.surveyDistributions);
    setVisibleSurveyDistribution(null);
    setVisibleSurveyContact(null);
    setVisibleMonitoredIndividual(null);
    setVisibleSurveyResponse(null);
    setCurrentMobileView('distributions');
  }

  const setVisibleSurveyDistributionThis = (surveyDistribution) => {
    if (logComponent('SurveyResponses')) { console.debug('SurveyResponses setVisibleSurveyDistributionThis'); }
    setVisibleSurveyDistribution(surveyDistribution);
    setContacts(surveyDistribution.surveyContacts);
    setVisibleSurveyContact(null);
    setVisibleMonitoredIndividual(null);
    setVisibleSurveyResponse(null);
    setCurrentMobileView('contacts');
  }

  const setSurveyDistributionListPage = (surveyDistribution) => {
    if (logComponent('SurveyResponses')) { console.debug('SurveyResponses setSurveyDistributionListPage'); }

    setContacts(surveyDistribution.surveyContacts);

  }

  const setVisibleSurveyContactThis = (surveyContact) => {
    if (logComponent('SurveyResponses')) { console.debug('SurveyResponses setVisibleSurveyContactThis'); }

    setVisibleSurveyContact(surveyContact);
    setMonitoredIndividuals(surveyContact.monitoredIndividuals);

    let newVisibleMonitoredIndividual = surveyContact.monitoredIndividuals && surveyContact.monitoredIndividuals.length > 0 ? surveyContact.monitoredIndividuals[0] : null;
    if (singlePanelView === true || newVisibleMonitoredIndividual == null) {
      setVisibleMonitoredIndividual(null);
      setVisibleSurveyResponse(null);
      setCurrentMobileView('individuals');
    }
    else {
      setVisibleMonitoredIndividual(newVisibleMonitoredIndividual);
      let newVisibleSurveyResponse = newVisibleMonitoredIndividual.surveyResponses && newVisibleMonitoredIndividual.surveyResponses.length > 0 ? newVisibleMonitoredIndividual.surveyResponses[0] : null;
      setVisibleSurveyResponse(newVisibleSurveyResponse);
      setCurrentMobileView('responses');

    }
    setCurrentMobileViewPage('details');

  }


  const setVisibleMonitoredIndividualThis = (monitoredIndividual) => {
    if (logComponent('SurveyResponses')) { console.debug('SurveyResponses setVisibleMonitoredIndividualThis'); }

    setVisibleMonitoredIndividual(monitoredIndividual);
    let newVisibleSurveyResponse = monitoredIndividual.surveyResponses && monitoredIndividual.surveyResponses.length > 0 ? monitoredIndividual.surveyResponses[0] : null;
    setVisibleSurveyResponse(newVisibleSurveyResponse);
    setCurrentMobileView('responses');
  }

  const getMobileHeading = () => {
    if (logComponent('SurveyResponses')) { console.debug('SurveyResponses getMobileHeading'); }

    switch (currentMobileView) {
      case 'surveys':
        return <p className="Survey-Responses__mobile-heading-text">Surveys</p>;
      case 'distributions':
        return (
          <React.Fragment>
            <button
              className="Survey-Responses__back-button"
              onClick={goBack} >
              <FontAwesomeIcon icon="chevron-left" className="Survey-Responses__back-button-icon" />
              Back
            </button>
            <p className="Survey-Responses__mobile-heading-text">Distributions</p>
          </React.Fragment>
        );
      case 'contacts':
        return (
          <React.Fragment>
            <button
              className="Survey-Responses__back-button"
              onClick={goBack} >
              <FontAwesomeIcon icon="chevron-left" className="Survey-Responses__back-button-icon" />
              Back
            </button>
            <p className="Survey-Responses__mobile-heading-text">Contacts</p>
          </React.Fragment>
        );
      case 'individuals':
        return (
          <React.Fragment>
            <button
              className="Survey-Responses__back-button"
              onClick={goBack} >
              <FontAwesomeIcon icon="chevron-left" className="Survey-Responses__back-button-icon" />
              Back
            </button>
            <p className="Survey-Responses__mobile-heading-text">Individuals</p>
          </React.Fragment>
        );
      case 'responses':
        return (
          <React.Fragment>
            <button
              className="Survey-Responses__back-button"
              onClick={goBack} >
              <FontAwesomeIcon icon="chevron-left" className="Survey-Responses__back-button-icon" />
              Back
            </button>
            <p className="Survey-Responses__mobile-heading-text">Responses</p>
          </React.Fragment>
        );
      default:
        return null;
    }
  }

  const goBack = () => {
    if (logComponent('SurveyResponses')) { console.debug('SurveyResponses goBack'); }
    let newMobileView = currentMobileView;
    switch (currentMobileView) {
      case 'distributions':
        newMobileView = 'surveys';
        break;
      case 'contacts':
        newMobileView = 'distributions';
        break;
      case 'individuals':
        newMobileView = 'contacts';
        break;
      case 'responses':
        newMobileView = 'individuals';
        break;
      case 'default':
        newMobileView = 'surveys';
        break;
    }
    setCurrentMobileView(newMobileView);
  }

  const goBackToSummary = () => {
    if (logComponent('SurveyResponses')) { console.debug('SurveyResponses goBack'); }
    setCurrentMobileViewPage('summary');
  }

  return (
    <div className="Survey-Responses">
      <div className="Survey-Responses__main">
        {
          !singlePanelView
            ?
            currentMobileViewPage === 'summary'
              ?
              <React.Fragment>
                <p className="Survey-Responses__heading">Survey Responses</p>
                <div className="Survey-Responses__section-header-bar">
                  <div className="Survey-Responses__section-header-bar-inner">
                    <p className="Survey-Responses__heading-surveys">Surveys</p>
                    <p className="Survey-Responses__heading-distributions">Distributions</p>
                    <p className="Survey-Responses__heading-contacts">Contacts</p>

                  </div>
                </div>

              </React.Fragment>
              :
              <React.Fragment>
                <p className="Survey-Responses__heading">Messages</p>
                <div className="Survey-Responses__section-header-bar">
                  <div className="Survey-Responses__section-header-bar-inner">
                    <p className="Survey-Responses__heading-individuals">Individuals</p>
                    <p className="Survey-Responses__heading-responses">Responses</p>
                    <p className="Survey-Responses__heading-notes">Notes</p>

                  </div>
                </div>

              </React.Fragment>

            :
            <div className="Survey-Responses__mobile-heading">{getMobileHeading()}</div>
        }
        {
          surveyResponsesCollections &&
          (!singlePanelView
            ?
            currentMobileViewPage === 'summary'
              ?

              <React.Fragment>
                <div className="Survey-Responses__content">
                  {
                    surveyResponsesCollections &&
                    <SurveyResponsesSurveyList
                      surveyResponsesCollections={surveyResponsesCollections}
                      selectedSurvey={visibleSurvey}
                      onSelect={setVisibleSurveyThis} />
                  }
                  {
                    distributions &&
                    <SurveyResponsesSurveyDistributionList
                      distributions={distributions}
                      selectedDistribution={visibleSurveyDistribution}
                      onSelect={setVisibleSurveyDistributionThis}
                      onPageChanged={setSurveyDistributionListPage }
                    />
                  }
                  {
                    contacts &&
                    <SurveyResponsesSurveyContactList
                      contacts={contacts}
                      selectedDistribution={visibleSurveyContact}
                      onSelect={setVisibleSurveyContactThis} />
                  }
                </div>
              </React.Fragment>
              :
              <React.Fragment>
                <div className="Survey-Responses__content">
                  {
                    monitoredIndividuals &&
                    <SurveyResponsesSurveyMonitoredIndividualList
                      individuals={monitoredIndividuals}
                      selectedMonitoredIndividual={visibleMonitoredIndividual}
                      onSelect={setVisibleMonitoredIndividualThis} />
                  }
                  {
                    visibleSurveyResponse &&
                    <SurveyResponsesDetail
                      surveyResponse={visibleSurveyResponse}
                      onGoBackClick={goBackToSummary}
                    />
                  }



                </div>
              </React.Fragment>
            :
            <React.Fragment>
              {
                currentMobileView !== 'surveys' &&
                <div className="Survey-Responses__survey-info-bar">
                  <div className="Survey-Responses__survey-text">
                    <p className="Survey-Responses__survey-name">{`${visibleSurvey.surveyName}`}</p>
                    <p className="Survey-Responses__survey-organization">{`${visibleSurvey.organizationName}`}</p>
                  </div>
                  {currentMobileView !== 'distributions' && visibleSurveyDistribution &&
                    <div>
                      <div className="Survey-Responses__distribution-text">
                          <p className="Survey-Responses__distribution-description">{`Distribution`}</p>
                          <p className="Survey-Responses__distribution-start-end">{`Start on: ${format(parseISO(visibleSurveyDistribution.sendOn), 'MM/dd/yyyy')} End on: ${format(parseISO(visibleSurveyDistribution.expiresOn), 'MM/dd/yyyy')}`}</p>
                      </div>
                      {currentMobileView !== 'contacts' && visibleSurveyContact &&
                        <div>
                          <div className="Survey-Responses__contact-text">
                              <p className="Survey-Responses__contact-description">{`Contact`}</p>
                              <p className="Survey-Responses__contact-name">{`${visibleSurveyContact.name}`}</p>
                          </div>
                          {currentMobileView !== 'monitoredIndividuals' && visibleMonitoredIndividual &&
                            <div className="Survey-Responses__individual-text">
                                <p className="Survey-Responses__individual-description">{`Individual`}</p>
                                <p className="Survey-Responses__individual-name">{`${visibleMonitoredIndividual.legalFirstName} ${visibleMonitoredIndividual.lastName}`}</p>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }

                </div>
              }

              <div className="Messages__content">
                {
                  currentMobileView === 'surveys' && surveyResponsesCollections &&
                  <SurveyResponsesSurveyList
                    fullWidth={true}
                    surveyResponsesCollections={surveyResponsesCollections}
                    selectedSurvey={visibleSurvey}
                    onSelect={setVisibleSurveyThis} />
                }
                {
                  currentMobileView === 'distributions' && distributions &&
                  <SurveyResponsesSurveyDistributionList
                    fullWidth={true}
                    distributions={distributions}
                    selectedDistribution={visibleSurveyDistribution}
                    onSelect={setVisibleSurveyDistributionThis} />
                }
                {
                  currentMobileView === 'contacts' && contacts &&
                  <SurveyResponsesSurveyContactList
                    fullWidth={true}
                    contacts={contacts}
                    selectedDistribution={visibleSurveyContact}
                    onSelect={setVisibleSurveyContactThis} />
                }
                {
                  currentMobileView === 'individuals' && monitoredIndividuals &&
                  <SurveyResponsesSurveyMonitoredIndividualList
                    fullWidth={true}
                    individuals={monitoredIndividuals}
                    selectedMonitoredIndividual={visibleMonitoredIndividual}
                    onSelect={setVisibleMonitoredIndividualThis} />
                }
                {
                  currentMobileView === 'responses' && visibleSurveyResponse &&
                  <SurveyResponsesDetail
                    fullWidth={true}
                    surveyResponse={visibleSurveyResponse} />
                }
              </div>
            </React.Fragment>

          )
        }
        {
          surveyResponsesCollectionsOnDeck &&
          surveyResponsesCollectionsOnDeck.length > 0 &&
          <button
            className="Survey-Responses__load-more-button"
            onClick={loadMoreSurveyResponses}>Load more</button>
        }
        <ModuleLoadingStatus isLoading={dataLoading} isError={dataError} reloadAction={loadSurveyResponses} />
      </div>
    </div>
  );
}